import apiSlice from './apiSlice';

const apiSliceWithTag = apiSlice.enhanceEndpoints({ addTagTypes: ['Reviews'] });

const fetchAdvancedReview = apiSliceWithTag.injectEndpoints({
  endpoints: (builder) => ({
    fetchAdvancedReview: builder.query({
      query: ({ ean, education, gen, marital, lt, gt }) => ({
        url: `/community/products/${ean}/advanced_rating/`,
        method: 'GET',
        params: {
          educational_level: education,
          gender: gen,
          marital_status: marital,
          age_lt: lt,
          age_gt: gt,
        },
      }),
      providesTags: ['Reviews'],
    }),
  }),
});

export const { useFetchAdvancedReviewQuery } = fetchAdvancedReview;
export default fetchAdvancedReview;
